import React from "react";
import ReactDOM from "react-dom";
import Game from "./Game";
import "./index.css";

ReactDOM.render(<Game />, document.getElementById("root"));
